module.exports = __webpack_public_path__ + "img/液体.bb9bcba4.png";